// extracted by mini-css-extract-plugin
export default {"productGallery":"LL-z","inQuickShop":"ML-z"};